import { render, staticRenderFns } from "./Change-User.vue?vue&type=template&id=4c1fb204"
import script from "./Change-User.vue?vue&type=script&lang=js"
export * from "./Change-User.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports